/**
 * Enums de conductor
 * Enumeraciones relacionadas con documentos de conductores
 */

/**
 * Categorías principales de documentos de conductores
 */
export enum DriverDocumentCategory {
  DNI = 'dni',
  DRIVING_LICENSE = 'driving_license',
  DRIVING_POINTS = 'driving_points',
  SELF_EMPLOYMENT = 'self_employment',
  BANK_ACCOUNT = 'bank_account',
  CRIMINAL_RECORD = 'criminal_record',
  TAX = 'tax',
  SOCIAL_SECURITY = 'social_security',
  NIE = 'nie'
}

export const driverDocumentCategoryDescriptions: Record<DriverDocumentCategory, string> = {
  [DriverDocumentCategory.DNI]: 'driverDocumentCategory.DNI',
  [DriverDocumentCategory.DRIVING_LICENSE]: 'driverDocumentCategory.DRIVING_LICENSE',
  [DriverDocumentCategory.DRIVING_POINTS]: 'driverDocumentCategory.DRIVING_POINTS',
  [DriverDocumentCategory.SELF_EMPLOYMENT]: 'driverDocumentCategory.SELF_EMPLOYMENT',
  [DriverDocumentCategory.BANK_ACCOUNT]: 'driverDocumentCategory.BANK_ACCOUNT',
  [DriverDocumentCategory.CRIMINAL_RECORD]: 'driverDocumentCategory.CRIMINAL_RECORD',
  [DriverDocumentCategory.TAX]: 'driverDocumentCategory.TAX',
  [DriverDocumentCategory.SOCIAL_SECURITY]: 'driverDocumentCategory.SOCIAL_SECURITY',
  [DriverDocumentCategory.NIE]: 'driverDocumentCategory.NIE'
};

/**
 * Tipos específicos de documentos de conductores
 */
export enum DriverDocumentType {
  // DNI
  FRONT_DNI = 'front_dni',
  BACK_DNI = 'back_dni',

  // Carnet de conducir
  FRONT_DRIVING_LICENSE = 'front_driving_license',
  BACK_DRIVING_LICENSE = 'back_driving_license',

  // Autónomo
  SELF_EMPLOYMENT_REGISTRATION_FEE = 'self_employment_registration_fee',
  SELF_EMPLOYMENT_PAYMENT_CERTIFICATE = 'self_employment_payment_certificate',
  RETA_REGISTRATION_RESOLUTION = 'reta_registration_resolution',

  // Cuenta bancaria
  BANK_ACCOUNT_CERTIFICATE = 'bank_account_certificate',

  // Antecedentes penales
  CRIMINAL_RECORD_CERTIFICATE = 'criminal_record_certificate',

  // Puntos del carné
  DRIVING_POINTS_CERTIFICATE = 'driving_points_certificate',

  // Impuestos
  TAX_CENSUS_REGISTRATION_CERTIFICATE = 'tax_census_registration_certificate',
  TAX_DEBT_CERTIFICATE = 'tax_debt_certificate',
  FORM_036 = 'form_036',

  // Seguridad Social
  SOCIAL_SECURITY_COMPLIANCE_CERTIFICATE = 'social_security_compliance_certificate',

  // NIE
  RESIDENCE_PERMIT_NIE = 'residence_permit_nie',
  WORK_PERMIT_NIE = 'work_permit_nie'
}

/**
 * Estado del documento
 */
export enum DriverDocumentStatus {
  PENDING = 'pending',
  PENDANT = 'pendant',
  VALIDATED = 'validated',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  EXPIRED = 'expired'
}

export const driverDocumentStatusDescriptions: Record<DriverDocumentStatus, string> = {
  [DriverDocumentStatus.PENDING]: 'driverDocumentStatus.PENDING',
  [DriverDocumentStatus.PENDANT]: 'driverDocumentStatus.PENDANT',
  [DriverDocumentStatus.VALIDATED]: 'driverDocumentStatus.VALIDATED',
  [DriverDocumentStatus.APPROVED]: 'driverDocumentStatus.APPROVED',
  [DriverDocumentStatus.REJECTED]: 'driverDocumentStatus.REJECTED',
  [DriverDocumentStatus.EXPIRED]: 'driverDocumentStatus.EXPIRED'
};

/**
 * Tipo de razón de invalidación
 */
export enum DriverDocumentInvalidationReasonType {
  EXPIRED = 'expired',
  INVALID = 'invalid',
  ILLEGIBLE = 'illegible',
  INCOMPLETE = 'incomplete',
  OTHER = 'other'
}

export const driverDocumentInvalidationReasonTypeDescriptions: Record<DriverDocumentInvalidationReasonType, string> = {
  [DriverDocumentInvalidationReasonType.EXPIRED]: 'driverDocumentInvalidationReasonType.EXPIRED',
  [DriverDocumentInvalidationReasonType.INVALID]: 'driverDocumentInvalidationReasonType.INVALID',
  [DriverDocumentInvalidationReasonType.ILLEGIBLE]: 'driverDocumentInvalidationReasonType.ILLEGIBLE',
  [DriverDocumentInvalidationReasonType.INCOMPLETE]: 'driverDocumentInvalidationReasonType.INCOMPLETE',
  [DriverDocumentInvalidationReasonType.OTHER]: 'driverDocumentInvalidationReasonType.OTHER'
};
